export enum SearchOptionEnum {
  DISTRIBUTOR = "distributor",
  CHARITY = "charity",
  LOCATION = "location",
}
